import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MButton } from "@/components/ui/atoms/MButtons";
import { IconCircleCheck } from "@tabler/icons-react";
import { getMemberInfo } from "@/hooks/useMembers";
import { trackUserDataLoaded } from "@/utils/gtm";
import {
  ANALYTICS_SCREEN_TYPES,
  ANALYTICS_SCREEN_NAMES,
} from "@/constants/analytics.constants";

const InviteSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const nickname = location.state?.memberNickname;
  const memberName = nickname || location.state?.memberName || "";
  const backUrl = location.state?.backUrl || "/profile/family";
  const memberInfo = getMemberInfo(true);

  // Track GTM user_data_loaded event on page load
  React.useEffect(() => {
    if (!memberInfo?.id) return;

    trackUserDataLoaded({
      memberInfo,
      screenType: ANALYTICS_SCREEN_TYPES.FAMILY,
      screenName: ANALYTICS_SCREEN_NAMES.FAMILY_INFO_INVITE_RESENT,
    });
  }, [memberInfo?.id]);

  const handleDone = () => {
    navigate(backUrl);
  };

  return (
    <div className="flex-col items-center justify-center min-h-screen bg-white px-4 curvy-gradient-profile-success">
      <div
        style={{
          display: "flex",
          height: 48,
          padding: "12px 24px",
          alignItems: "center",
          gap: 10,
          flexShrink: 0,
          alignSelf: "stretch",
        }}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 24,
          padding: 24,
          marginTop: 64,
        }}
      >
        <div>
          <IconCircleCheck size={72} stroke={2.2} color="#C8B7E0" />
        </div>
        <div style={{ textAlign: "center" }} className="body-xl-bold">
          {nickname || memberName} has been sent an invite to join your Maatra
          family
        </div>
        <div
          style={{ textAlign: "center", lineHeight: 1.5 }}
          className="manageAccessEmptyText"
        >
          They'll get a link to set up their own profile and access shared
          family health records.
        </div>
        <div className="confirm-footer">
          <MButton
            variant="filled"
            size="lg"
            className="w-full"
            onClick={handleDone}
          >
            Done
          </MButton>
        </div>
      </div>
    </div>
  );
};

export default InviteSuccess;
